import _slicedToArray from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { implementsFunction } from "@thi.ng/checks";
import { EPS, eqDelta as _eq } from "@thi.ng/math";
import { compileHOF } from "./internal/codegen";
import { vop } from "./internal/vop";

var $ = function $(dim) {
  return eqDelta.add(dim, compileHOF(dim, [_eq, EPS], function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        a = _ref2[0],
        b = _ref2[1];

    return "eq(".concat(a, ",").concat(b, ",eps)");
  }, "eq,_eps", "a,b,eps=_eps", "a,b", null, "&&", "return a.length === b.length && ", ";"));
};

export var eqDelta = vop();
eqDelta["default"](function (v1, v2) {
  var eps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EPS;

  if (implementsFunction(v1, "eqDelta")) {
    return v1.eqDelta(v2, eps);
  }

  if (implementsFunction(v2, "eqDelta")) {
    return v2.eqDelta(v1, eps);
  }

  return eqDeltaS(v1, v2, v1.length, eps);
});
export var eqDelta2 = $(2);
export var eqDelta3 = $(3);
export var eqDelta4 = $(4);
/**
 * Similar to `equiv()`, but takes tolerance `eps` into account for
 * equality checks.
 *
 * @param a first vector
 * @param b second vector
 * @param n number of elements
 * @param eps tolerance
 * @param ia start index a
 * @param ib start index b
 * @param sa stride a
 * @param sb stride b
 */

export var eqDeltaS = function eqDeltaS(a, b, n) {
  var eps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : EPS;
  var ia = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var ib = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var sa = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1;
  var sb = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 1;

  for (; n > 0; n--, ia += sa, ib += sb) {
    if (!_eq(a[ia], b[ib], eps)) {
      return false;
    }
  }

  return true;
};
export var eqDeltaArray = function eqDeltaArray(a, b) {
  var eps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EPS;
  if (a === b) return true;
  if (a.length !== b.length) return false;

  for (var i = a.length; --i >= 0;) {
    if (!eqDelta(a[i], b[i], eps)) {
      return false;
    }
  }

  return true;
};
export var isInArray = function isInArray(p, pts) {
  var eps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EPS;

  for (var i = pts.length; --i >= 0;) {
    if (eqDelta(p, pts[i], eps)) {
      return true;
    }
  }

  return false;
};